import { TeacherActivity } from '../mockLesson';
import LessonPlanEditor from '../component/LessonPlanEditor';

interface LessonPlanPageProps {
    activities: TeacherActivity[];
    onBack: () => void;
    onContinue: () => void;
}

export default function LessonPlanPage({ activities, onBack, onContinue }: LessonPlanPageProps) {
    return <LessonPlanEditor activities={activities} onBack={onBack} onApprove={onContinue} />;
}
